<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          Master Kontraktor
        </h2>
        <p class="text-gray-500">
          Sini-Saja membantu mengelola & memantau perkembangan kegiatan
          kontraktor
        </p>
        <div class="flex gap-5 mt-5">
          <div class="flex gap-2 items-center cursor-pointer" @click="tambahKontraktor()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 20H2C0.89543 20 0 19.1046 0 18V6H2V18H14V20ZM18 16H6C4.89543 16 4 15.1046 4 14V2C4 0.89543 4.89543 0 6 0H18C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16ZM6 2V14H18V2H6ZM13 12H11V9H8V7H11V4H13V7H16V9H13V12Z"
                fill="#DD3737" />
            </svg>

            <h6 class="text-red-600 text-sm font-inter font-bold">
              Tambah Kontraktor
            </h6>
          </div>
          <div class="flex gap-2 items-center cursor-pointer" data-bs-toggle="modal" data-bs-target="#modalInactive"
            @click="getListKontraktorInactive">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 20H2C0.89543 20 0 19.1046 0 18V6H2V18H14V20ZM18 16H6C4.89543 16 4 15.1046 4 14V2C4 0.89543 4.89543 0 6 0H18C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16ZM6 2V14H18V2H6ZM13 12H11V9H8V7H11V4H13V7H16V9H13V12Z"
                fill="#DD3737" />
            </svg>

            <h6 class="text-red-600 text-sm font-inter font-bold">
              Tambah Inactive
            </h6>
          </div>
          <div class="flex gap-2 items-center cursor-pointer" @click="downloadExcel">
            <img src="../../assets/icon/download-excel.png" class="mix-blend-multiply min-w-5 w-5 h-auto cursor-pointer"
              alt="" />
            <h6 class="text-green-600 text-sm font-inter font-bold">
              Download Excel
            </h6>
          </div>
        </div>
        <v-row class="bg-white rounded-lg p-3 shadow-md mt-5">
          <v-col cols="3">
            <v-text-field variant="outlined" density="compact" color="red" hide-details clearable
              v-model="formValues.keyword" v-on:keyup.enter="cariKontraktor" prepend-inner-icon="mdi-magnify"
              placeholder="Masukkan Nama Kontraktor"></v-text-field>
          </v-col>
          <v-col cols="3">
            <select class="form-select form-select-md bg-slate-50 text-slate-600 capitalize" name="workArea"
              id="workArea" v-model="selectedWorkArea">
              <option disabled value="">Pilih Work Area</option>
              <option v-for="(row, index) in workAreaOption" :key="index" :value="row.value">
                {{ row.label }}
              </option>
            </select>
          </v-col>
          <v-col cols="3">
            <v-btn data-bs-toggle="modal" data-bs-target="#exampleModal" prepend-icon="mdi-filter"
              class="w-full bg-slate-50 text-slate-600 capitalize">
              Cari Berdasarkan
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn class="bg-red-600 w-full text-white capitalize" @click="cariKontraktor()">
              Cari Kontraktor
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <div class="my-8 rounded-lg shadow-md overflow-x-auto w-full">
        <v-data-table-server v-model:page="dataTable.pagination.page"
          v-model:items-per-page="dataTable.pagination.itemsPerPage" :items-per-page-options="[5, 10, 25, 50, 100]"
          :headers="dataTable.headers" :items="dataTable.items" :items-length="dataTable.pagination.totalItems"
          @update:options="fetchData">
          <template v-slot:item="{ item, index }">
            <tr class="border-b border-gray-950 h-16" :class="{ 'bg-gray-50': index % 2 !== 0 }">
              <td>
                <div class="flex gap-2 items-center">
                  <img src="../../assets/images/search.png" @click="redirectToLink('/profileKontraktor/', item.id)"
                    class="mix-blend-multiply min-w-5 w-5 h-auto cursor-pointer" alt="" />
                  <i :hidden="item.id != item.parentKontraktor"
                    class="mdi mdi-delete text-red-600 text-2xl cursor-pointer" @click="hapusKontraktor(item.id)"></i>
                </div>
              </td>
              <td class="text-nowrap">{{ item.namaKontraktor }}</td>
              <td class="text-nowrap">{{ item.inisial }}</td>
              <td class="text-nowrap">
                <div class="flex items-center gap-2 text-nowrap">
                  <span v-if="!item.workArea || item.workArea.length === 0">-</span>
                  <span v-else class="flex items-center gap-2">
                    <template v-for="(area, idx) in parseWorkArea(item.workArea)" :key="idx">
                      <img v-if="area === 'BIB'" src="../../assets/icon/mining-red.png" alt="BIB"
                        class="mix-blend-multiply min-w-7 w-7 h-auto" />
                      <img v-else-if="area === 'Mining'" src="../../assets/icon/mining-black.png" alt="Mining"
                        class="mix-blend-multiply min-w-7 w-7 h-auto" />
                      <img v-else-if="area === 'Hauling'" src="../../assets/icon/truck-orange.png" alt="Hauling"
                        class="mix-blend-multiply min-w-7 w-7 h-auto" />
                      <img v-else-if="area === 'Port'" src="../../assets/icon/Harbor.png" alt="Port"
                        class="mix-blend-multiply min-w-7 w-7 h-auto" />
                      <img v-else-if="area === 'Project'" src="../../assets/icon/hat-orange.png" alt="Project"
                        class="mix-blend-multiply min-w-7 w-7 h-auto" />
                      <img v-else src="../../assets/icon/others.png" alt="Others"
                        class="mix-blend-multiply min-w-7 w-7 h-auto" />
                      <span>{{ area }}</span>
                    </template>
                  </span>
                </div>
              </td>
              <td class="text-wrap">
                <span class="font-bold">
                  {{
                    item.isMainKontraktor ? "Main Kontraktor" : "Subkontraktor"
                  }} </span><br />
                <div v-if="item.dataSubkontraktor"
                  class="mt-1 bg-cyan-accent-1 text-black text-sm rounded px-2 py-1 inline-block">
                  Subkontraktor: {{ item.dataSubkontraktor }}
                </div>
              </td>
              <td class="text-nowrap">{{ item.kualifikasiUsaha }}</td>
              <td class="text-wrap">{{ item.alamat }}</td>
              <td>
                <div class="flex items-center gap-2 text-nowrap">
                  <span class="flex">NIB : </span>
                  <span class="flex">
                    {{ item.noNib == null ? "-" : item.noNib }}
                  </span>
                </div>
                <div class="flex items-center gap-2 text-nowrap">
                  <span class="flex">IUJP : </span>
                  <span class="flex">
                    {{ item.noIujp == null ? "-" : item.noIujp }}
                  </span>
                </div>
              </td>
              <td class="text-nowrap">{{ item.jenis }}</td>
              <td class="capitalize text-nowrap">
                <div class="px-1 rounded-md flex items-center gap-2 w-fit" :class="{
                  'bg-[#ffe5e5] text-[#dd3737]':
                    item.tingkatResiko === 'Tinggi',
                  'bg-[#f4eadb] text-[#ff8800]':
                    item.tingkatResiko === 'Sedang',
                  'bg-[#ddfbec] text-[#0c8953]':
                    item.tingkatResiko === 'Rendah',
                  'bg-[#c8bde0] text-[#720c89]':
                    item.tingkatResiko === 'Kritis',
                }">
                  <i class="mdi mdi-circle text-[8px]" v-if="
                    ['Tinggi', 'Sedang', 'Rendah', 'Kritis'].includes(
                      item.tingkatResiko,
                    )
                  "></i>
                  <span class="font-semibold">{{ item.tingkatResiko }}</span>
                </div>
              </td>
              <td class="text-nowrap">
                {{ item.nilaiPraKplh }}
              </td>
              <td class="text-nowrap">
                {{
                  item.tanggalBerakhir
                    ? moment(item.tanggalBerakhir).format("DD/MMM/YYYY")
                    : "-"
                }}
              </td>
              <td class="text-nowrap">{{ item.wilayah }}</td>
              <td class="text-nowrap">
                {{
                  item.tglExpIujp == null
                    ? "-"
                    : moment(item.tglExpIujp).format("DD/MMM/YYYY")
                }}
              </td>
              <td class="text-nowrap">
                {{ item.nilaiPredikat }}
                <span v-if="item.predikat == 'HIJAU'" class="text-success">
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span v-else-if="item.predikat == 'EMAS'" style="color: #e19140">
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span v-else-if="item.predikat == 'BIRU'" style="color: #326bd5">
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span v-else-if="item.predikat == 'HITAM'" style="color: #171716">
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span v-else-if="item.predikat == 'MERAH'" class="text-danger">
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
              </td>
              <td class="text-nowrap">{{ item.namaPjo }}</td>
              <td class="text-nowrap">
                {{ item.kompetensiPjo }}
              </td>
              <td class="text-nowrap">{{ item.picName }}</td>
              <td class="text-nowrap">{{ item.picEmail }}</td>
            </tr>
          </template>
        </v-data-table-server>
      </div>
    </v-row>
  </DefaultLayout>
  <!-- modal filter -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>

        </div> -->
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <div class="d-flex justify-content-end w-100">
            <button type="button" id="btnClose" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="izinKerja" class="form-label fs-8 fw-bold">Izin Kerja</label>
              <input type="text" class="form-control fs-9" id="izinKerja" placeholder="Masukkan Nomor Izin Kerja"
                v-model="formValues.izinKerja" />
            </div>
            <div class="col-md-6">
              <label for="nilai_pra_kplh" class="form-label fs-8 fw-bold">Nilai Prakualifikasi</label>
              <input type="text" class="form-control fs-9" id="nilai_pra_kplh" placeholder="Masukkan Nilai"
                v-model="formValues.nilaiPraKplh" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="mb-1">
                <label for="jenis" class="form-label fs-8 fw-bold">Jenis</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="radio" value="inti" id="jenis_inti"
                    v-model="formValues.jenis" />
                  <label class="form-check-label fs-9" for="jenis_inti">
                    Inti
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="non_inti" id="jenis_non_inti"
                    v-model="formValues.jenis" />
                  <label class="form-check-label fs-9" for="jenis_non_inti">
                    Non Inti
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-1">
                <label for="wilayah" class="form-label fs-8 fw-bold">Wilayah</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="radio" value="lokal" id="wilayah_lokal"
                    v-model="formValues.wilayah" />
                  <label class="form-check-label fs-9" for="wilayah_lokal">
                    Lokal
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="non_lokal" id="wilayah_non_lokal"
                    v-model="formValues.wilayah" />
                  <label class="form-check-label fs-9" for="wilayah_non_lokal">
                    Non Lokal
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="">
                <label for="kode_kbli" class="form-label fs-8 fw-bold">Kode KBLI</label>
                <input type="text" class="form-control fs-9" id="kode_kbli" placeholder="Masukkan Kode KBLI"
                  v-model="formValues.kbli" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="">
                <label for="keyword_kbli" class="form-label fs-8 fw-bold">Keyword KBLI</label>
                <input type="text" class="form-control fs-9" id="keyword_kbli" placeholder="Masukkan Keyword KBLI"
                  v-model="formValues.keywordKbli" />
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="mb-1">
                <label for="jenis" class="form-label fs-8 fw-bold">Kompetensi</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="pou" id="komp_pou"
                    v-model="formValues.kompetensi" />
                  <label class="form-check-label fs-9" for="komp_pou">
                    POU
                  </label>
                </div>
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="pop" id="komp_pop"
                    v-model="formValues.kompetensi" />
                  <label class="form-check-label fs-9" for="komp_pop">
                    POP
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="pom" id="komp_pom"
                    v-model="formValues.kompetensi" />
                  <label class="form-check-label fs-9" for="komp_pom">
                    POM
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label for="nama_pjo" class="form-label fs-8 fw-bold">Nama PJO</label>
              <input type="text" class="form-control fs-9" id="nama_pjo" placeholder="Masukkan Nama PJO"
                v-model="formValues.namaPjo" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="">
                <label for="bidang" class="form-label fs-8 fw-bold">Bidang</label>
                <input type="text" class="form-control fs-9" id="keyword_bidang" placeholder="Masukkan Bidang"
                  v-model="formValues.bidang" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="">
                <label for="subBidang" class="form-label fs-8 fw-bold">Sub Bidang</label>
                <input type="text" class="form-control fs-9" id="keyword_subbidang" placeholder="Masukkan Sub bidang"
                  v-model="formValues.subbidang" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 mt-1">
          <button class="btn btn_cari w-100 fs-8 fw-bold" @click="terapkan">
            Terapkan
          </button>
          <button class="btn btn_refresh w-100 fs-8 fw-bold" @click="refresh">
            Refresh Filter
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="workAreaModal" tabindex="-1" aria-labelledby="workAreaModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <div class="d-flex justify-content-end w-100">
            <button type="button" id="btnClose" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="all" class="form-label fs-8 fw-bold">All</label>
              <input type="text" class="form-control fs-9" id="all" placeholder="Masukkan Nomor Izin Kerja"
                v-model="formValues.izinKerja" />
            </div>
            <div class="col-md-6">
              <label for="bib" class="form-label fs-8 fw-bold">BIB</label>
              <input type="text" class="form-control fs-9" id="bib" placeholder="Masukkan Nilai"
                v-model="formValues.nilaiPraKplh" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="mb-1">
                <label for="jenis" class="form-label fs-8 fw-bold">Kompetensi</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="BIB" id="bib"
                    v-model="formValues.kompetensi" />
                  <label class="form-check-label fs-9" for="komp_pou">
                    BIB
                  </label>
                </div>
                <div class="form-check" style="margin-right: 1rem">
                  <input class="form-check-input" type="checkbox" value="pop" id="komp_pop"
                    v-model="formValues.kompetensi" />
                  <label class="form-check-label fs-9" for="komp_pop">
                    POP
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="pom" id="komp_pom"
                    v-model="formValues.kompetensi" />
                  <label class="form-check-label fs-9" for="komp_pom">
                    POM
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label for="nama_pjo" class="form-label fs-8 fw-bold">Nama PJO</label>
              <input type="text" class="form-control fs-9" id="nama_pjo" placeholder="Masukkan Nama PJO"
                v-model="formValues.namaPjo" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="">
                <label for="bidang" class="form-label fs-8 fw-bold">Bidang</label>
                <input type="text" class="form-control fs-9" id="keyword_bidang" placeholder="Masukkan Bidang"
                  v-model="formValues.bidang" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="">
                <label for="subBidang" class="form-label fs-8 fw-bold">Sub Bidang</label>
                <input type="text" class="form-control fs-9" id="keyword_subbidang" placeholder="Masukkan Sub bidang"
                  v-model="formValues.subbidang" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 mt-1">
          <button class="btn btn_cari w-100 fs-8 fw-bold" @click="terapkan">
            Terapkan
          </button>
          <button class="btn btn_refresh w-100 fs-8 fw-bold" @click="refresh">
            Refresh Filter
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modalInactive" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <div class="d-flex justify-content-end w-100">
            <button type="button" id="btnClose" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="mb-3">
            <h2 class="text-danger fw-bold">Kontraktor Inactive</h2>
            <p class="text-secondary">Daftar kontraktor yang tidak aktif</p>
          </div>
          <div class="row d-flex mb-3">
            <div class="col-md-4">
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1"><font-awesome-icon icon="fa-solid fa-magnifying-glass"
                    style="color: #000000" /></span>
                <input type="text" class="form-control" placeholder="Masukkan Nama Kontraktor" aria-label="keyword"
                  aria-describedby="basic-addon1" v-model="Inactive.keyword"
                  v-on:keyup.enter="getListKontraktorInactive" />
              </div>
            </div>
            <div class="col-md-4">
              <button type="button" @click="getListKontraktorInactive()" class="btn btn_cari w-100">
                Cari Kontraktor
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped mb-0" style="
                max-width: 100%;
                overflow-x: auto;
                font-family: 'Inter-Regular', serif;
              ">
              <thead style="
                  font-family: 'Inter-Regular', serif;
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 24px;
                  color: #28293d;
                ">
                <tr>
                  <th class="bg_thead_body" width="5%">No.</th>
                  <th class="bg_thead_body">Nama Kontraktor</th>
                  <th class="bg_thead_body" width="8%">Action</th>
                </tr>
              </thead>
              <tbody style="
                  font-family: 'Inter-Regular';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 24px;
                  color: #28293d;
                ">
                <tr v-for="(inactive, index) in kontraktorsInactive" :key="inactive.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ inactive.namaKontraktor }}</td>
                  <td>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" :id="'inactive' + inactive.id"
                        @click="ubahInactive(inactive.id)" />
                    </div>
                  </td>
                </tr>
                <tr v-if="!kontraktorsInactive.length">
                  <td class="text-center" colspan="3">
                    Tidak ada data kontraktor inactive
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex align-items-center justify-content-end w-100"
              style="height: 5vh; background-color: #f8d7da">
              <div class="w-100 d-flex align-items-center justify-content-end fs-6">
                <label for="size">Item Per Page</label>
                <select name="size" id="size" class="mx-2" v-model="Inactive.size" @change="getListKontraktorInactive">
                  <option value="5" selected>5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <p id="stat_table" class="mb-1">
                  {{
                    Inactive.currentPage * Inactive.size - (Inactive.size - 1)
                  }}-{{
                    Inactive.currentPage * Inactive.size -
                    (Inactive.size - 1) +
                    (kontraktorsInactive.length - 1)
                  }}
                  of {{ Inactive.totalData }}
                </p>
                <button class="btn mr-2 mb-1" id="prev_page_table" @click="changeInactivePage(-1)">
                  &lt;
                </button>
                <button class="btn mb-1" id="next_page_table" @click="changeInactivePage(1)">
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img src="../../assets/icons/Spinner-1s-200px.svg" style="height: 10rem" alt="" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GlobalDataMixin from "../../GlobalDataMixin";
// import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
// import SidebarComponent from "@/components/SideBar.vue";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_EXPORT_KONTRAKTOR,
  CMS_GET_INTERNAL_KONTRAKTOR,
  CMS_LIST_KONTRAKTOR_INACTIVE,
} from "@/constants";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import axiosInstance from "@/plugins/axios";

const url = API_BASE_URL + CMS_GET_INTERNAL_KONTRAKTOR;
const list_inactive = API_BASE_URL + CMS_LIST_KONTRAKTOR_INACTIVE;
const url_download_excel = API_BASE_URL + CMS_EXPORT_KONTRAKTOR;

export default {
  mixins: [GlobalDataMixin],
  name: "MdKontraktorPage",
  title: "Master Kontraktor",
  components: { DefaultLayout },
  data() {
    return {
      isLoading: false,
      dataTable: CreateDataTableObject([
        { title: "", align: "start", sortable: false, width: "3%" },
        {
          title: "Nama Kontraktor",
          key: "kontraktor_name",
          align: "start",
          sortable: true,
          width: "10%",
        },
        {
          title: "Inisial",
          key: "inisial",
          align: "start",
          sortable: true,
          width: "5%",
        },
        {
          title: "Work Area",
          key: "work_area",
          align: "start",
          sortable: true,
          width: "5%",
        },
        {
          title: "Status",
          key: "status",
          align: "start",
          sortable: false,
          width: "15%",
        },
        {
          title: "Kualifikasi Usaha",
          key: "kualifikasi_usaha",
          align: "start",
          sortable: false,
          width: "10%",
        },
        {
          title: "Alamat Kontraktor",
          key: "alamat",
          align: "start",
          sortable: true,
          width: "25%",
        },
        {
          title: "Izin Kerja",
          key: "nib",
          align: "start",
          sortable: true,
          width: "8%",
        },
        {
          title: "Jenis",
          key: "jenis",
          align: "start",
          sortable: true,
          width: "6%",
        },
        {
          title: "Tingkat Resiko",
          key: "tingkat_resiko",
          align: "start",
          sortable: true,
          width: "6%",
        },
        {
          title: "Nilai Prakualifikasi",
          key: "pra_kplh",
          align: "start",
          sortable: true,
          width: "6%",
        },
        {
          title: "Tanggal Berakhir Pra KPLH",
          align: "start",
          sortable: false,
          width: "6%",
        },
        {
          title: "Wilayah",
          key: "wilayah",
          align: "start",
          sortable: true,
          width: "6%",
        },
        {
          title: "Masa Aktif IUJP",
          key: "iujp_exp",
          align: "start",
          sortable: true,
          width: "8%",
        },
        {
          title: "Nilai Predikat",
          key: "nilai_predikat",
          align: "start",
          sortable: false,
          width: "10%",
        },
        { title: "Nama PJO", align: "start", sortable: false, width: "8%" },
        { title: "Kompetensi", align: "start", sortable: false, width: "9%" },
        {
          title: "PIC Name",
          key: "picName",
          align: "start",
          sortable: true,
          width: "7%",
        },
        {
          title: "PIC Email",
          key: "picEmail",
          align: "start",
          sortable: true,
          width: "7%",
        },
      ]),

      kontraktors: [],
      currentPage: 1,
      totalData: 0,
      linkaddKontraktor: "/manajement/add-kontraktor",
      formValues: {
        keyword: "",
        perPage: 5,
        izinKerja: "",
        jenis: "",
        wilayah: "",
        isKbli: false,
        kbli: "",
        keywordKbli: "",
        namaPjo: "",
        kompetensi: [],
        nilaiPraKplh: "",
        nilaiKplh: "",
        bidang: "",
        subbidang: "",
        keywordWorkArea: "",
      },
      sortField: null,
      sortMethod: null,
      kontraktorsInactive: [],
      Inactive: {
        currentPage: 1,
        size: 5,
        totalData: 0,
        keyword: null,
        checked: null,
      },
      selectedWorkArea: "All",
      workAreaOption: [
        { label: "All", value: "All" },
        { label: "BIB", value: "BIB" },
        { label: "Mining", value: "Mining" },
        { label: "Hauling", value: "Hauling" },
        { label: "Port", value: "Port" },
        { label: "Project", value: "Project" },
        { label: "ROM", value: "ROM" },
        { label: "Others", value: "Others" },
      ],
      filtersInitialized: false,
    };
  },
  created() {
    this.initFiltersFromQuery();
  },
  mounted() {
    this.initFiltersFromQuery();
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.fetchData();
    }
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      this.formValues.keyword = q.keyword ?? null;
      this.formValues.izinKerja = q.izinKerja ?? "";
      this.formValues.jenis = q.jenis ?? "";
      this.formValues.wilayah = q.wilayah ?? "";
      this.formValues.kbli = q.kbli ?? "";
      this.formValues.keywordKbli = q.keywordKbli ?? "";
      this.formValues.namaPjo = q.namaPjo ?? "";
      this.formValues.kompetensi = q.kompetensi
        ? Array.isArray(q.kompetensi)
          ? q.kompetensi
          : [q.kompetensi]
        : [];
      this.formValues.nilaiPraKplh = q.nilaiPraKplh ?? "";
      this.formValues.nilaiKplh = q.nilaiKplh ?? "";
      this.formValues.bidang = q.bidang ?? "";
      this.formValues.subbidang = q.subbidang ?? "";
      if (q.workArea !== undefined && q.workArea !== "")
        this.selectedWorkArea = q.workArea;
      if (q.page !== undefined && q.page !== "") {
        this.currentPage = Number(q.page);
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.perPage !== undefined && q.perPage !== "") {
        this.formValues.perPage = Number(q.perPage);
        this.dataTable.pagination.itemsPerPage = Number(q.perPage);
      }
    },
    syncFiltersToUrl() {
      const query = {
        keyword: this.formValues.keyword || undefined,
        workArea:
          this.selectedWorkArea && this.selectedWorkArea !== "All"
            ? this.selectedWorkArea
            : undefined,
        izinKerja: this.formValues.izinKerja || undefined,
        jenis: this.formValues.jenis || undefined,
        wilayah: this.formValues.wilayah || undefined,
        kbli: this.formValues.kbli || undefined,
        keywordKbli: this.formValues.keywordKbli || undefined,
        namaPjo: this.formValues.namaPjo || undefined,
        kompetensi:
          this.formValues.kompetensi && this.formValues.kompetensi.length
            ? this.formValues.kompetensi
            : undefined,
        nilaiPraKplh: this.formValues.nilaiPraKplh || undefined,
        nilaiKplh: this.formValues.nilaiKplh || undefined,
        bidang: this.formValues.bidang || undefined,
        subbidang: this.formValues.subbidang || undefined,
        page:
          this.dataTable.pagination.page > 1
            ? this.dataTable.pagination.page
            : undefined,
        perPage:
          this.dataTable.pagination.itemsPerPage !== 5
            ? this.dataTable.pagination.itemsPerPage
            : undefined,
      };
      this.$router.replace({ query }).catch(() => { });
    },
    buildKontraktorQuery() {
      const q = {};
      if (this.formValues.keyword) q.keyword = this.formValues.keyword;
      if (this.selectedWorkArea && this.selectedWorkArea !== "All")
        q.workArea = this.selectedWorkArea;
      if (this.formValues.izinKerja) q.izinKerja = this.formValues.izinKerja;
      if (this.formValues.jenis) q.jenis = this.formValues.jenis;
      if (this.formValues.wilayah) q.wilayah = this.formValues.wilayah;
      if (this.formValues.kbli) q.kbli = this.formValues.kbli;
      if (this.formValues.keywordKbli)
        q.keywordKbli = this.formValues.keywordKbli;
      if (this.formValues.namaPjo) q.namaPjo = this.formValues.namaPjo;
      if (this.formValues.kompetensi && this.formValues.kompetensi.length)
        q.kompetensi = this.formValues.kompetensi;
      if (this.formValues.nilaiPraKplh)
        q.nilaiPraKplh = this.formValues.nilaiPraKplh;
      if (this.formValues.nilaiKplh) q.nilaiKplh = this.formValues.nilaiKplh;
      if (this.formValues.bidang) q.bidang = this.formValues.bidang;
      if (this.formValues.subbidang) q.subbidang = this.formValues.subbidang;
      if (this.dataTable.pagination.page > 1)
        q.page = this.dataTable.pagination.page;
      if (this.dataTable.pagination.itemsPerPage !== 5)
        q.perPage = this.dataTable.pagination.itemsPerPage;
      return q;
    },
    tambahKontraktor() {
      this.$router.push({
        path: "/manajement/add-kontraktor",
        query: this.buildKontraktorQuery(),
      });
    },
    closeModal() {
      document.getElementById("btnClose").click();
    },
    terapkan() {
      this.closeModal();
      this.cariKontraktor();
    },
    refresh() {
      this.formValues.keyword = null;
      this.formValues.izinKerja = "";
      this.formValues.jenis = "";
      this.formValues.wilayah = "";
      this.formValues.isKbli = false;
      this.formValues.kbli = "";
      this.formValues.keywordKbli = "";
      this.formValues.namaPjo = "";
      this.formValues.kompetensi = [];
      this.formValues.nilaiPraKplh = "";
      this.formValues.nilaiKplh = "";
      this.formValues.bidang = "";
      this.formValues.subbidang = "";
      this.selectedWorkArea = "All";
      this.currentPage = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.closeModal();
      this.fetchData();
    },
    redirectToLink(link, id) {
      this.$router.push({
        path: link + id,
        query: this.buildKontraktorQuery(),
      });
    },
    resetPaginasi() {
      this.kontraktors = [];
      this.formValues.perPage = 5;
      this.currentPage = 1;
      this.totalData = 0;
    },
    cariKontraktor() {
      this.resetPaginasi();
      this.syncFiltersToUrl();
      this.fetchData();
    },
    fetchData({ page, itemsPerPage, sortBy } = {}) {
      let val_lokal = null;
      let val_inti = null;
      if (this.formValues.wilayah != "") {
        val_lokal = this.formValues.wilayah == "lokal" ? true : false;
      }
      if (this.formValues.jenis != "") {
        val_inti = this.formValues.jenis == "inti" ? true : false;
      }

      if (this.formValues.kbli != "" || this.formValues.keywordKbli != "") {
        this.formValues.isKbli = true;
      } else {
        this.formValues.isKbli = false;
      }

      if (page) {
        this.currentPage = page;
        this.dataTable.pagination.page = page;
      }
      if (itemsPerPage) {
        this.formValues.perPage = itemsPerPage;
        this.dataTable.pagination.itemsPerPage = itemsPerPage;
      }
      this.syncFiltersToUrl();

      var bodyJson = {
        header: {
          page: this.currentPage,
          perPage: this.formValues.perPage,
          usecase: "bebas",
        },
        lokal: val_lokal,
        inti: val_inti,
        isKbli: this.formValues.isKbli,
        kbli: this.formValues.kbli,
        keywordKbli: this.formValues.keywordKbli,
        namaPjo: this.formValues.namaPjo,
        kompetensiPjo: this.formValues.kompetensi,
        nilaiPraKplh: this.formValues.nilaiPraKplh,
        nilaiKplh: this.formValues.nilaiKplh,
        keyword: this.formValues.keyword,
        bidang: this.formValues.bidang,
        subBidang: this.formValues.subbidang,
        ob: sortBy ? sortBy[0]?.key : null,
        sort: sortBy ? sortBy[0]?.order : null,
        keywordWorkArea:
          this.selectedWorkArea === "All" ? null : this.selectedWorkArea,
      };
      axios
        .post(url, bodyJson)
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.countData;
          result.total_per_page = this.formValues.perPage;
          result.current_page = this.currentPage;

          this.dataTable = SetDataTableResponse(this.dataTable, result);
          console.log(response);
          this.kontraktors = response.data.data;
          this.totalData = response.data.countData;
          console.log(this.kontraktors);
        })
        .catch((error) => {
          if (error.response?.status != 400) {
            alert("Error Fetch Data List Kontraktor : " + error.message);
            console.error("Error fetching data:", error);
          } else {
            this.kontraktors = [];
            this.totalData = 0;
          }
        });
    },
    changeInactivePage(num) {
      let cp = this.Inactive.currentPage + num;
      if (
        !(num == -1 && this.Inactive.currentPage == 1) &&
        cp * this.Inactive.size <=
        this.Inactive.totalData + (this.Inactive.size - 1)
      ) {
        this.Inactive.currentPage = this.Inactive.currentPage + num;
        this.getListKontraktorInactive();
      }
    },
    hapusKontraktor(id) {
      Swal.fire({
        title: "Apakah Anda yakin akan menghapus kontraktor ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteKontraktor(id);
        }
      });
    },
    async deleteKontraktor(id) {
      try {
        await axiosInstance.delete("cms/kontraktor", {
          params: {
            id: id,
            updated_by: this.userData.name,
          },
        });

        Swal.fire({
          title: "Hapus Kontraktor",
          text: "Data Kontraktor telah dihapus !",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan (" + (error.response?.data?.message || error.message) + ")",
        });
      }
    },
    getListKontraktorInactive() {
      let bodyJson = {
        page: this.Inactive.currentPage,
        size: this.Inactive.size,
        namaKontraktor: this.Inactive.keyword,
      };
      axios
        .get(list_inactive, {
          params: bodyJson,
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then((response) => {
          this.kontraktorsInactive = response.data.data;
          this.Inactive.totalData = response.data.countData;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ubahInactive(id) {
      Swal.fire({
        title: "Apakah Anda yakin akan mengaktifkan kembali kontraktor ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateInactive(id);
        } else {
          let input = document.querySelector("#inactive" + id);
          input.checked = !input.checked;
        }
      });
    },
    async updateInactive(id) {
      try {
        await axiosInstance.put(
          "cms/kontraktor/reactivate",
          {},
          {
            params: {
              id: id,
              updated_by: this.userData.name,
            },
          },
        );

        Swal.fire({
          title: "Kontraktor Aktif",
          text: "Kontraktor berhasil diaktifkan !",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          location.reload();
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan (" + (error.response?.data?.message || error.message) + ")",
        });
      }
    },
    async downloadExcel() {
      this.isLoading = true;
      try {
        const response = await axios.get(url_download_excel, {
          responseType: "blob", // Important: treat the response as a binary file
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Optional: custom file name
        link.download = "data_kontraktor.xlsx";

        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Failed to download Excel:", error);
      } finally {
        this.isLoading = false;
      }
    },
    parseWorkArea(raw) {
      // Handles both actual arrays and strings like "[Hauling, ROM]"
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "string") {
        return raw.replace(/[[\]\s]/g, "").split(",");
      }
      return [];
    },
  },

  computed: {
    colClass() {
      return this.userData == null ? "col-md-12" : "col-md-10 col-lg-10";
    },
  },

  watch: {
    selectedWorkArea() {
      if (!this.filtersInitialized) return;
      this.resetPaginasi();
      this.fetchData();
    },
  },
};
</script>

<style scoped>
:deep(table) {
  table-layout: auto !important;
  width: max-content !important;
  min-width: 100%;
}

:deep(thead) {
  background-color: #fecaca;
}

/* :deep(.v-data-table-footer) {
  background-color: #fecaca;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
} */
</style>
